module.exports = __webpack_public_path__ + "static/media/icon_error-data.e14d6e67.svg";